import { Link } from 'react-router-dom'

export default function NotFound() {
  return (
    <div className="relative min-h-screen overflow-hidden bg-stone-50">
      {/* Background layers match primary design */}
      <div className="absolute inset-0 mesh-gradient" aria-hidden="true"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-white/70 via-white/60 to-white/80" aria-hidden="true"></div>

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-center min-h-screen">
        <div className="bg-white/80 backdrop-blur-xl border border-white/60 shadow-2xl rounded-3xl p-10 sm:p-12 text-center space-y-6">
          <div className="w-14 h-14 mx-auto rounded-2xl bg-emerald-50 text-emerald-600 flex items-center justify-center shadow-inner">
            <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.6} d="M12 9v2m0 4h.01M4.93 19.07a10 10 0 1114.14 0A10 10 0 014.93 19.07z" />
            </svg>
          </div>

          <div className="space-y-2">
            <p className="text-sm font-semibold text-emerald-600 tracking-wide">Oops! Page missing</p>
            <h1 className="text-3xl sm:text-4xl font-display font-bold text-stone-900">404 - Page Not Found</h1>
            <p className="text-stone-600 max-w-2xl mx-auto">
              The page you’re looking for isn’t available. Head back home to continue
              finding verified properties or managing your dashboard.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/"
              className="inline-flex items-center justify-center px-6 py-3 rounded-xl bg-emerald-600 text-white font-semibold shadow-lg shadow-emerald-500/20 hover:bg-emerald-700 transition-all duration-200"
            >
              Go Home
            </Link>
            <Link
              to="/auth"
              className="inline-flex items-center justify-center px-6 py-3 rounded-xl border border-stone-200 text-stone-800 font-semibold hover:border-emerald-300 hover:text-emerald-700 hover:shadow-md transition-all duration-200"
            >
              Sign In
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

